export enum StatusEnum {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  CANCELLED = 'CANCELLED',
  FINISHED = 'FINISHED',
  SENT = 'SENT',
}
